export enum FeatureDetailType {
  NotApplicable = 'NotApplicable',
  MissingValue = 'MissingValue',
  Unknown = 'Unknown',
}
